import { render, staticRenderFns } from "./StockStorePopup.vue?vue&type=template&id=28c41466&scoped=true&"
import script from "./StockStorePopup.vue?vue&type=script&lang=js&"
export * from "./StockStorePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c41466",
  null
  
)

export default component.exports